// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

export const RewardsGrid = styled.div({
  display: 'grid',
  width: '100%',
  gridTemplateColumns: 'repeat(2, 1fr)',
});
